export const GSEA_PRODUCT_ID = 'prod_V8vqnidduq4O7k';
export const GSEA_PRO_PRODUCT_ID = 'prod_V8vrBM2S54ykA5';

export const FEATURE_TRIAL_DAYS = 7;
